import template from './verticalTab.html';
import VerticalTabController from './verticalTab.controller';
import './vertical-tab.less';

const VerticalTabComponent = {
  bindings: {
    tabs: '<',
    form: '<',
    formData: '<',
    setInvalidClassOnSolutions: '<',
    setNoSolutionSelected: '&',
  },
  template,
  controller: VerticalTabController
};

export default VerticalTabComponent;



// WEBPACK FOOTER //
// ./src/components/search-form/vertical-tab/verticalTab.component.js